/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentFirmwareFamily } from './equipment-firmware-family';
import { EquipmentScheduleWarningDto } from './equipment-schedule-warning-dto';
import { EquipmentScheduleConflictDto } from './equipment-schedule-conflict-dto';


export interface EquipmentScheduleDeviceIssuesResponse { 
    equipmentId?: string;
    ipAddress?: string | null;
    macAddress?: string | null;
    modelName?: string | null;
    firmwareFamily?: EquipmentFirmwareFamily;
    conflicts?: Array<EquipmentScheduleConflictDto> | null;
    warnings?: Array<EquipmentScheduleWarningDto> | null;
    facilityName?: string | null;
    containerName?: string | null;
    containerNumber?: number | null;
}



